<template>
  <el-dialog
    width="60%"
    class="dialog"
    title="旧机记录"
    :visible.sync="dialogFormVisible"
  >
    <el-table :data="list">
      <el-table-column
        prop="feedbackType"
        label="操作类型"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="feedbackUserName"
        label="操作人"
        width="200"
      ></el-table-column>
      <el-table-column prop="feedbackTime" label="操作时间" width="200">
        <template slot-scope="scope">
          {{ scope.row.feedbackTime | formatDateTimeDefault }}
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注说明"
        width="320"
      ></el-table-column>
    </el-table>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { getOldMachineDetail } from "@/api/oldForNew";

export default {
  components: {},
  data() {
    return {
      dialogFormVisible: false,
      list: []
    };
  },
  watch: {},
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false;
    },
    // 打开弹框
    async openDialog(workOrderId) {
      const param = { id: workOrderId };
      let { data, statusCode } = await getOldMachineDetail(param);
      if (statusCode == 200) {
        this.list = data;
        console.log("旧机操作流水", data);
      }
      this.dialogFormVisible = true;
    }
  }
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .tips {
    margin-bottom: 10px;
  }
  .el-dialog__body {
    paddding-top: 10px;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/components/searchOldDetailDialog.vue